import Vue from 'vue'
import VueI18Next from '@panter/vue-i18next'
import VueScrollTo from 'vue-scrollto'
import checkView from 'vue-check-view'
import { configure } from 'vee-validate'
import i18next from '@/i18n'
import store from '@/store'
import router from '@/router'

import App from '@/App'
import smoothscroll from 'smoothscroll-polyfill'

Vue.use(checkView)
Vue.use(VueI18Next)
Vue.use(VueScrollTo)

Vue.config.productionTip = false

// global vee-validate settings
configure({
    mode: 'aggressive',
    classes: {
        valid: 'is-valid',
        invalid: 'is-invalid'
    },
    defaultMessage: (_, values) => i18next.t(`error:${values._rule_}`, values)
})
// END: global vee-validate settings

const i18n = new VueI18Next(i18next)

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')

smoothscroll.polyfill()
